import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AdminLogin = () => {
  const nav = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // If arriving with a session_id, let AdminDashboard handle it.
    if (location.hash?.includes("session_id=")) {
      nav("/admin/dashboard" + location.hash, { replace: true });
      return;
    }
    // Otherwise check if we already have a valid session.
    const check = async () => {
      try {
        const r = await fetch(`${BASE}/api/admin/auth/me`, { credentials: "include" });
        if (r.ok) {
          nav("/admin/dashboard", { replace: true });
          return;
        }
      } catch {
        /* ignore */
      }
      setChecking(false);
    };
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div
      className="min-h-screen w-full dots-bg flex items-center justify-center px-4 py-10"
      data-testid="admin-login-page"
    >
      <div
        className="chunky-card pop-in w-full max-w-md p-6 sm:p-8 text-center"
        style={{ background: "#fff" }}
      >
        <div
          className="rounded-full mx-auto flex items-center justify-center mb-3"
          style={{
            width: 72,
            height: 72,
            background: "#5F27CD",
            color: "#fff",
            border: "3px solid #2b2b2b",
            boxShadow: "0 5px 0 #2b2b2b",
          }}
        >
          <ShieldCheck size={34} strokeWidth={3} />
        </div>
        <h1 className="font-display text-2xl sm:text-3xl" style={{ color: "#5F27CD" }}>
          67Cafe Admin
        </h1>
        <p className="mt-2 text-sm" style={{ color: "#484848" }}>
          Sign in with the authorized Google account.
          <br />
          Only the account owner has access.
        </p>
        <button
          type="button"
          onClick={signIn}
          disabled={checking}
          className="btn-3d btn-purple mt-6 w-full"
          data-testid="admin-google-signin"
        >
          {checking ? "Checking session…" : "Sign in with Google"}
          {!checking && <ArrowRight size={18} strokeWidth={3} />}
        </button>
        <div className="mt-4 text-xs" style={{ color: "#8a8a8a" }}>
          <Link to="/shop" className="underline">
            ← Back to the cafe
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
